import React, { useMemo, useState } from "react";
import Stack from "@mui/material/Stack";
import Badge from "@mui/material/Badge";
import {
  AlertComponent,
  SearchInputComponent,
} from "../../common/components";
import FilterIcon from "../../assets/icons/filter-icon.svg"
import { useNavigate } from "react-router-dom";
import { useResourcePermissions } from "../../common/hooks/resource-permissions";
import MODULES from "../../constants/modules";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useLogin } from "../../common/hooks/useUser";
import { TicketFilterProps } from "../afp-support/types";

const TicketFilter: React.FC<TicketFilterProps> = (props) => {
  const {
    isOpenFilter,
    setIsOpenFilter,
    selectedTicketsFilter,
    onSearch,
    searchRef,
    isResetSearch,
  } = props;
  const navigate = useNavigate();
  const { canWrite, canDelete } = useResourcePermissions(MODULES.LEAD_DETAILS);
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const [alertType, setAlertType] = useState<
    "error" | "success" | "info" | "warning"
  >("info");
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const userDetails = useLogin();
  const userRole = userDetails.userDetails.roles.role;
  const isMobile = useMediaQuery("(max-width:768px)");
  const { canExport } = useResourcePermissions(MODULES.EXPORT);

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  return (
    <div className="lead-list-search-filter-wrapper">
      {isMobile ? (
        <div className="search-filter-group">
          <div className="lead-list-search-wrapper">
            <SearchInputComponent
              placeholder="Search by Ticket ID, Partner Name, Subject"
              onSearch={onSearch}
              isReset={isResetSearch}
              ref={searchRef}
            />
          </div>

          <div
            className="lead-list-icon-filter"
            onClick={() => setIsOpenFilter(!isOpenFilter)}
            tabIndex={0}
          >
            <Stack spacing={4} direction="row" sx={{ color: "action.active" }}>
              <Badge
                color="secondary"
                sx={{
                  "& .MuiBadge-badge": {
                    backgroundColor: "#887952",
                  },
                }}
                badgeContent={selectedTicketsFilter}
              >
                <img src={FilterIcon} alt="Filter Icon" />
              </Badge>
            </Stack>
          </div>
        </div>
      ) : (
        <div className="lead-list-search-wrapper">
          <SearchInputComponent
              placeholder="Search by Ticket ID, Partner Name, Subject"
            onSearch={onSearch}
            isReset={isResetSearch}
            ref={searchRef}
          />
        </div>
      )}
      <div className="lead-list-filter-wrapper">
        {!isMobile && (
          <div
            className="lead-list-icon-filter"
            onClick={() => setIsOpenFilter(!isOpenFilter)}
            tabIndex={0}
          >
            <Stack spacing={4} direction="row" sx={{ color: "action.active" }}>
              <Badge
                color="secondary"
                sx={{
                  "& .MuiBadge-badge": {
                    backgroundColor: "#887952",
                  },
                }}
                badgeContent={selectedTicketsFilter}
              >
                <img src={FilterIcon} alt="Filter Icon" />
              </Badge>
            </Stack>
          </div>
        )}
      </div>
      <AlertComponent
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={handleAlertClose}
      />
    </div>
  );
};

export default TicketFilter;
